<template>
    <v-dialog
        v-model="dialog"
        max-width="1000"
        content-class="spillard-dialog"
    >

        <v-card>
            <div class="close" @click="dialog = !dialog">
                <i class="material-icons">close</i>
            </div>
            <div class="info-block">
                Live view
            </div>
            <v-card-text>
                <div class="loading" v-if="isLoading">
                    <v-progress-circular
                        :size="30"
                        color="rgba(255, 255, 255)"
                        indeterminate
                    ></v-progress-circular>
                    Loading...
                </div>
                <v-container fluid class="container">
                    <template v-if="media.type === 0">

                        <v-layout row wrap>
                            <v-flex v-if="!media.list.length && isLoading==false" md12><h4
                                class="no-active-device-info"> This device has no active channels </h4></v-flex>
                            <v-flex md6 class="video-section" v-for="media in media.list"
                                    :key="`live_${media.channelFlag}_${media.url}`">
                                <video-mpeg
                                    v-show="media.uri != null"
                                    :channel-number="media.channelFlag"
                                    :url="media.uri"
                                    :tracks="media.overlayUris"
                                    is-live-stream
                                    @numberLoadedVideo="numberLoadedVideo"
                                    :is-video-loaded="isVideoLoaded"
                                ></video-mpeg>
                            </v-flex>
                        </v-layout>
                    </template>
                    <template v-if="media.type == 2">

                        <v-layout v-if="media.type===2" row wrap>
                            <v-flex v-if="!media.list.length && isLoading==false" md12><h4
                                class="no-active-device-info"> This device has no active channels </h4></v-flex>
                            <v-flex md6 class="video-section" v-for="media in media.list"
                                    :key="`live_${media.channelFlag}_${media.url}`">
                                <video-player-hls :url="media.uri" :channelName="media.channelFlag" isLive/>
                            </v-flex>

                        </v-layout>
                    </template>

                    <template v-if="media.type !== 2 && media.type !== 0">
                        <v-layout row wrap>
                            <v-flex v-if="!media.list.length && isLoading==false" md12><h4
                                class="no-active-device-info">
                                This device has no active channels </h4></v-flex>
                            <v-flex md6 class="video-section" v-for="media in media.list"
                                    :key="`live_${media.channelFlag}_${media.url}`">
                                <video-player
                                    :channelName="getChannels.find(channel => channel.id === media.channelFlag).key"
                                    :url="media.uri" isLive></video-player>
                            </v-flex>
                        </v-layout>
                    </template>
                </v-container>

            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import moment from 'moment'
import { DEVICE_CHANNELS_LIST } from '@/config/consts'
import VideoPlayer from './components/VideoPlayer'
import toast from '@/plugins/izitoast'
import { StreamingApi } from '@/api'
import VideoMPEG from '@/components/atoms/VideoMPEG'
import { mapGetters } from 'vuex'
import VideoPlayerHls from '@/views/Journeys/components/VideoPlayerHls.vue'

const streamingApi = new StreamingApi()

export const vm = {
    name: 'Videos',
    components: {
        VideoPlayerHls,
        VideoPlayer,
        'video-mpeg': VideoMPEG
    },
    async mounted () {
    },
    data () {
        return {
            dialog: false,
            isStreaming: false,
            isLoading: true,
            isStartStreamingRequestSent: false,
            players: {
                channelOne: null,
                channelTwo: null,
                channelThree: null,
                channelFour: null
            },
            playerOptions: {
                techOrder: ['flash', 'html5'],
                flash: {
                    mediaDataSource: {
                        isLive: true,
                        cors: true,
                        withCredentials: false
                    }
                }
            },
            videoChannelOne: null,
            availableChannels: [],
            media: {
                type: null,
                list: []
            },
            availableVideos: [],
            isVideoLoaded: false,
            counter: 0
        }
    },
    props: {
        value: {
            type: Boolean,
            default: false
        },
        vehicleUuid: {
            type: String,
            required: true
        },
        availableChannelsFlag: {
            type: Number,
            required: false
        },
        hardwareId: {
            type: String,
            required: true
        }
    },
    computed: {
        ...mapGetters('dictionaryModule', [
            'getChannels'
        ])
    },
    watch: {
        dialog (val) {
            if (val) {
                this.isLoading = true
                this.requestLiveStream()
            } else {
                if (this.isStreaming && !this.isStartStreamingRequestSent) {
                    this.stopStreaming()
                }
            }
            this.$emit('input', val)
        },
        isStreaming (val) {
            this.$emit('isStreaming', val)
        }
    },
    methods: {
        async requestLiveStream () {
            this.isStreaming = true
            this.isStartStreamingRequestSent = true
            const response = await streamingApi.requestLive(
                this.hardwareId,
                2,
                this.getChannels.reduce((a, b) => a + b.id, 0)
            )

            if (!response.isSuccess || null == response.payload) {
                this.loadingStreaming = false
                this.isError = true
                this.isLoading = false
                return
            }

            if (0 !== response.payload.statusCode) {
                this.handleRequestError(response.payload.statusCode)
                this.isLoading = false
                this.dialog = false
                return
            }

            this.media.type = response.payload.standardType
            response.payload.urls.forEach((item) => {
                if (item.isActive) {
                    this.media.list.push({
                        channelFlag: item.channel,
                        uri: item.url
                    })
                }
            })
            if (1 > this.media.list.length) toast.error('This device has no active channels')
            this.isStartStreamingRequestSent = false
            this.loadingStreaming = false

            if (!this.dialog) this.stopStreaming()

            this.isLoading = false
            console.log(this.media.type)
        },
        handleRequestError (statusCode) {
            this.loadingStreaming = false
            this.isError = true

            switch (statusCode) {
                case 1:
                    toast.error('The device has been disconnected, try again later')
                    return
                case 2:
                    toast.error('The device has timed out, try again later')
                    return
                case 3:
                    toast.error('There has been an error, try again later')
                    return
                case 4:
                    toast.error('The device is Busy, try again later')
                    return
                case 5:
                    toast.error('No footage has been found on the device')
                    return
                default:
                    toast.error('Unknown error occured, please try again later')
            }
        },
        async stopStreaming () {
            this.media.list = []

            await streamingApi.stopLive(this.hardwareId)
            this.isStartStreamingRequestSent = false
            this.isStreaming = false
        },
        numberLoadedVideo () {
            this.counter += 1
            this.isVideoLoaded = false
            if (this.media.list.length === this.counter) {
                this.isVideoLoaded = true
                this.counter = 0
            }
        }
    }
}

export default vm

</script>

<style scoped lang="scss">
.info-block {
    margin-bottom: 20px;
}

.title {
    text-align: center;
    background: $secondary;
    color: white;
    padding: 13px 0;
    font-weight: bold;
}

.container {
    padding: 0 24px;
}

.player {
    position: absolute !important;
    width: 100%;
    height: 60%;
}

.video-section {
    padding: 10px 5px;
}

.loading {
    position: absolute;
    background: rgba(0, 0, 0, 0.8);
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    display: flex;
    align-items: center;
    justify-content: center;
    color: $white;

    .v-progress-circular {
        margin-right: 10px;
    }
}

.close {
    position: absolute;
    top: 18px;
    right: 20px;
    cursor: pointer;

    &:hover {
        opacity: 0.7;
    }
}

.no-active-device-info {
    text-align: center;
}
</style>

<style lang="scss">
.video-js {
    width: 100% !important;
    height: 350px !important;
}
</style>
